import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from 'react-router-dom';
import { Icon } from "@iconify/react";
import { toast } from "react-toastify";
import closeIcon from '@iconify/icons-mdi/close-circle-outline';
import { getData, postData, putData, deleteData } from '../../../webService/webservice.js';
import "../../../styles/Auth/subscription.css";
import CreatableSelect from "react-select/creatable";
import makeAnimated from "react-select/animated";
import { Modal, Box, Typography, Button } from "@mui/material";
import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TableContainer,
    Paper,
    Tooltip
} from "@mui/material";
import TVFMLoader from "../Loader/loader.jsx";
import { useStore } from "../../../Context/context.jsx";
import AddStoreForm from "../store/AddStoreForm.jsx";
import StoreMultiSelect from "../../Challange/storeMultiSelect.jsx";
import StoreSingleAllStoresSelect, { ALL_STORE_OPTION } from "../../Challange/StoreSingleAllStoresSelect.jsx";
import Footer from "../Footer/Footer-page.jsx";
const SubscriptionPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const role = localStorage.getItem("role");
    const adminStoreIds = JSON.parse(localStorage.getItem("storeIds") || "[]");
    const initialStoreId = adminStoreIds[0] || "";
    const [stores, setStores] = useState([]);
    const isAddSubscription = location.pathname === '/membership/add';
    const [searchQuery, setSearchQuery] = useState('');
    const [subscriptions, setSubscriptions] = useState([]);
    const [refreshKey, setRefreshKey] = useState(0);
    const [customers, setCustomers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [toggle, setToggle] = useState(false);
    const [open, setOpen] = useState(false);
    const [limit, setLimit] = useState(5);
    const [isPopupMode, setIsPopupMode] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [editSubscriptionId, setEditSubscriptionId] = useState(null);
    const [showLoader, setShowLoader] = useState(false);
    const [isAddStore, setIsAddStore] = useState(false);
    const [loaderText, setLoaderText] = useState('');
    const [subscriptionToDelete, setSubscriptionToDelete] = useState(null);
    const { selectedStoreId, setSelectedStoreId } = useStore();
    const [store, setStore] = useState(ALL_STORE_OPTION);
    const [isViewMode, setIsViewMode] = useState(false);
    const [viewSubscription, setViewSubscription] = useState(null);
    const [isGSTVerified, setIsGSTVerified] = useState(false);
    const colors = [
        "linear-gradient(135deg, #FDF3EF, #F7E2DC)",
        "linear-gradient(135deg, #F1F6FD, #E2ECF9)",
        "linear-gradient(135deg, #F4FDF7, #DFF3E6)"
    ];


    const headings = [
        "S.No",
        "Membership",
        "Code",
        "Value Type",
        "Benefit",
        "Price",
        "GST",
        "Cycle",
        "Action"
    ];

    const commonCellStyle = {
        color: '#525252',
        fontSize: '12px',
        fontWeight: 600,
        textAlign: 'center'
    };

    const [errors, setErrors] = useState({});
    const [formData, setFormData] = useState({
        subscriptionName: "",
        subscriptionCycle: "",
        subscriptionCycleCount: "",
        subscriptionValueType: "",
        subscriptionValue: "",
        subscriptionStartDate: "",
        subscriptionEndDate: "",
        gstAmount: "",
        gstPercentage: "",
        priceOfMembership: "",
        subscriptionTypesOptions: ['SILVER', 'GOLD', 'PLATINUM'],
        storeId: initialStoreId,
        storeName: "",
    });

    useEffect(() => {
        document.title = "Memberships | TVFM POS";
        const fetchStoreName = async () => {
            // Handle single storeId
            if (formData.storeId && !formData.storeName) {
                try {
                    const res = await getData(`stores/store/${formData.storeId}`, {}, sessionToken);
                    if (res?.data) {
                        setFormData(prev => ({
                            ...prev,
                            storeName: res.data.storeName
                        }));
                        const gstValid = res.data?.gstData?.valid === true;
                        setIsGSTVerified(gstValid);
                    }
                } catch (err) {
                    console.error("Failed to fetch store name", err);
                }
            }
        };
        fetchStoreName();
    }, [formData.storeId]);

    useEffect(() => {
        if (!isGSTVerified) {
            setFormData(prev => ({
                ...prev,
                gstPercentage: 0,
                gstAmount: "0.00"
            }));
        }
    }, [isGSTVerified]);

    const EMPTY_ARRAY = [];
    const sessionToken = localStorage.getItem("Token");

    const loadStores = async (inputValue, loadedOptions, { page }) => {
        try {
            const res = await getData(
                "stores/stores",
                { page, limit: 10, search: inputValue },
                sessionToken
            );

            const results = res?.data?.results || EMPTY_ARRAY;

            const options = results.map(store => ({
                value: store._id,
                label: store.storeName
            }));

            return {
                options,
                hasMore: results.length === 10,
                additional: { page: page + 1 }
            };

        } catch (err) {
            console.error("Store Fetch Failed", err);
            return { options: [], hasMore: false };
        }
    };

    const triggerRefresh = () => {
        setRefreshKey(prev => prev + 1);
    };

    const calculateGSTAmount = (price, gst) => {
        const base = Number(price || 0);
        const gstPercent = Number(gst || 0);
        return ((base * gstPercent) / 100).toFixed(2);
    };

    const handleAddSubscription = async (e) => {
        e.preventDefault();

        const validationErrors = validateFields(formData);

        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        setErrors({});
        setShowLoader(true);
        try {
            const token = localStorage.getItem("Token");

            const response = await postData("subscriptions/", formData, token);

            toast.success(response.message || "Membership added successfully");

            setFormData({
                subscriptionName: "",
                subscriptionCycle: "",
                subscriptionCycleCount: "",
                subscriptionValue: "",
                subscriptionStartDate: "",
                subscriptionEndDate: "",
                priceOfMembership: "",
                gstAmount: "",
                gstPercentage: "",
            });

            triggerRefresh();
            navigate("/membership");
            fetchSubscriptions();

        } catch (error) {
            console.error("Add Subscription Error:", error);
            toast.error(error.message || "Add Subscription Failed");
        } finally {
            setTimeout(() => {
                setShowLoader(false);
            }, 1000);
        }
    };


    const handleUpdateSubscription = async (e) => {
        e.preventDefault();

        setShowLoader(true);
        try {
            const token = localStorage.getItem("Token");

            const updatedSubscriptionData = {
                subscriptionName: formData.subscriptionName,
                subscriptionCycle: formData.subscriptionCycle,
                subscriptionCycleCount: formData.subscriptionCycleCount !== undefined && formData.subscriptionCycleCount !== null && formData.subscriptionCycleCount !== "" ? formData.subscriptionCycleCount : "0",
                subscriptionValueType: formData.subscriptionValueType,
                subscriptionValue: formData.subscriptionValue,
                storeId: formData.storeId,
                priceOfMembership: formData.priceOfMembership,
                gstAmount: formData.gstAmount,
                gstPercentage: formData.gstPercentage,
                subscriptionStartDate: formData.subscriptionStartDate,
                subscriptionEndDate: formData.subscriptionEndDate,
            };

            console.log("Updating Subscription with data:", updatedSubscriptionData);

            const response = await putData(
                `subscriptions/${editSubscriptionId}`,
                updatedSubscriptionData,
                token
            );

            toast.success(response.message || "Membership updated successfully");

            setFormData({
                subscriptionName: "",
                subscriptionCycle: formData.subscriptionCycle,
                subscriptionCycleCount: "",
                subscriptionValueType: formData.subscriptionValueType,
                subscriptionValue: "",
                storeId: "",
                priceOfMembership: "",
                gstAmount: "",
                gstPercentage: "",
                subscriptionStartDate: "",
                subscriptionEndDate: "",
            });

            setIsPopupMode(false);
            setIsEditMode(false);
            fetchSubscriptions();
            triggerRefresh();

        } catch (error) {
            toast.error("Error updating subscription.");
        } finally {
            setTimeout(() => {
                setShowLoader(false);
            }, 1000);
        }
    };

    const handleOpen = (subscriptionId) => {
        setSubscriptionToDelete(subscriptionId);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setSubscriptionToDelete(null);
    };

    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalCount, setTotalCount] = useState(0);

    const handleItemsPerPageChange = (e) => {
        setLimit(e.target.value);
        setCurrentPage(1);
    };

    const handlePageChange = (direction) => {
        setCurrentPage((prev) => {
            if (direction === "first") return 1;
            if (direction === "last") return totalPages;
            if (direction === "next") return Math.min(prev + 1, totalPages);
            if (direction === "prev") return Math.max(prev - 1, 1);
            return prev;
        });
    };

    useEffect(() => {
        fetchSubscriptions(searchQuery);
    }, [refreshKey, searchQuery, selectedStoreId, store, currentPage, limit]);

    const fetchSubscriptions = async (searchQuery) => {
        const params = {
            subscriptionName: searchQuery?.trim() || "",
            subscriptionCode: searchQuery?.trim() || "",
            page: currentPage,
            limit: limit
        }
        const sid = role === "SuperAdmin" || role === "SelfAdmin" ? store?.value : Array.isArray(selectedStoreId)
            ? selectedStoreId[0]
            : selectedStoreId;
        if (sid && sid.length === 24) {
            params.storeId = sid;
        }

        try {
            setLoading(true);
            const token = localStorage.getItem("Token");
            const response = await getData('subscriptions/subscriptions', params, token);
            if (response?.status !== 200) {
                toast.error(response?.message || "Failed to fetch membership");
                return;
            }
            const resultsWrapper = response?.data;
            const subscriptionsList = resultsWrapper?.results || [];
            const pages = resultsWrapper?.totalPages || 1;
            const count = resultsWrapper?.totalItems || 0; // The API returns 'totalItems' not 'totalCount'

            setSubscriptions(subscriptionsList);
            setTotalPages(pages);
            setTotalCount(count);

        } catch (error) {
            console.error('Fetch Subscriptions Error:', error);
            toast.error(error.message || 'Fetch Subscriptions Failed');
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        const fetchCustomers = async () => {
            try {
                const token = localStorage.getItem("Token");
                const data = await getData('customers/customers', {}, token);
                const results = data?.data?.[0]?.paginatedResults || [];
                setCustomers(results);
            } catch (error) {
                console.error("Failed to load customers", error);
            }
        };

        fetchCustomers();
    }, []);

    useEffect(() => {
        const fetchStores = async () => {
            try {
                const token = localStorage.getItem("Token");
                const data = await getData('stores/stores', {}, token);
                const results = data?.data?.results || [];
                setStores(results);

            } catch (error) {
                console.error("Failed to load Stores", error);
            }
        };
        fetchStores();
    }, []);

    useEffect(() => {
        document.title = "Reports Summary | TVFM POS";
    }, []);

    useEffect(() => {
        const handleStoreChange = () => {
            const storeId = selectedStoreId;
            setSelectedStoreId(storeId);
        };

        window.addEventListener("storeChanged", handleStoreChange);
        return () => window.removeEventListener("storeChanged", handleStoreChange);
    }, []);

    const formatDateTime = (dateStr) => {
        if (!dateStr) return "";
        return new Date(dateStr).toISOString().slice(0, 16);
    };

    const validateFields = (data) => {
        let newErrors = {};
        if (!data.subscriptionName) newErrors.subscriptionName = "Membership Type is required";
        if (!data.subscriptionCycle) newErrors.subscriptionCycle = "Membership Cycle is required";

        return newErrors;
    }

    const CustomOption = (props) => {
        const { data, innerRef, innerProps, isFocused } = props;

        // SAFETY CHECK → React Select may pass null temporarily
        if (!data) return null;

        return (
            <div
                ref={innerRef}
                {...innerProps}
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "8px 12px",
                    cursor: "pointer",
                    background: isFocused ? "#eee" : "#fff",
                }}
            >
                <span>{data.label}</span>

                {/* DELETE BUTTON */}
                <button
                    type="button"
                    onClick={(e) => {
                        e.stopPropagation();

                        // Remove membership type
                        props.setFormData(prev => ({
                            ...prev,
                            subscriptionTypesOptions: prev.subscriptionTypesOptions.filter(
                                t => t !== data.value
                            ),
                            subscriptionName:
                                prev.subscriptionName === data.value ? "" : prev.subscriptionName,
                        }));
                    }}
                    style={{
                        background: "transparent",
                        border: "none",
                        color: "red",
                        cursor: "pointer",
                        fontSize: "14px",
                        marginLeft: "8px",
                    }}
                >
                    ✕
                </button>
            </div>
        );
    };

    const handleDeleteSubscription = async (e) => {
        e.preventDefault();
        try {
            const token = localStorage.getItem('Token');
            const response = await deleteData(`subscriptions/subscription/${subscriptionToDelete}`, token);
            toast.success(response.message || "Subscription deleted successfully");
            setSubscriptionToDelete(null);
            fetchSubscriptions();
            handleClose();
            triggerRefresh(); // Refresh list
        } catch (error) {
            console.error("Delete error:", error);
            toast.error(error.message || "Failed to delete Subscription");
        }
    }

    return (
        <div className="product-layout">
            <div className="product-content">
                {showLoader && (
                    <div className="scissor-overlay">
                        <div className="scissor-loader">
                            <TVFMLoader />
                        </div>
                    </div>
                )}
                <main className="product-main">
                    {isAddSubscription ? (
                        <div className="add-Subscription-form">
                            <Typography variant="h6" gutterBottom>Add Membership</Typography>
                            <form className="subscription-form" onSubmit={handleAddSubscription} >
                                <div className="Subscription-form-row subscription-form-grid">
                                    {/* Store Name */}
                                    <div className="Subscription-form-group">
                                        <label className="input-label">Store Name</label>
                                        <StoreMultiSelect
                                            value={
                                                formData.storeId
                                                    ? [{
                                                        value: formData.storeId,
                                                        label:
                                                            formData.storeName ||
                                                            stores.find(s => s._id === formData.storeId)?.storeName ||
                                                            ""
                                                    }]
                                                    : []
                                            }
                                            onChange={(val) => {
                                                if (adminStoreIds.length === 1) return;

                                                setFormData(prev => ({
                                                    ...prev,
                                                    storeId: val?.[0]?.value || "",
                                                    storeName: val?.[0]?.label || "",
                                                }));
                                            }}
                                            loadStores={loadStores}
                                            loggedInRole={role}
                                            assignedStoreIds={adminStoreIds}
                                            isDisabled={adminStoreIds.length === 1}
                                        />
                                    </div>

                                    {/* Membership Type */}
                                    <div className="Subscription-form-group">
                                        <label className="input-label">Membership Type</label>
                                        <CreatableSelect
                                            components={{
                                                ...makeAnimated(),
                                                Option: (props) => (
                                                    <CustomOption {...props} setFormData={setFormData} />
                                                ),
                                            }}
                                            options={(formData.subscriptionTypesOptions ?? []).map(type => ({
                                                value: type,
                                                label: type,
                                            }))}
                                            placeholder="Select or type"
                                            isClearable
                                            isSearchable
                                            value={
                                                formData.subscriptionName
                                                    ? { value: formData.subscriptionName, label: formData.subscriptionName }
                                                    : null
                                            }
                                            onChange={(selectedOption) => {
                                                if (selectedOption) {
                                                    const value = selectedOption.value.toUpperCase();
                                                    setFormData(prev => ({
                                                        ...prev,
                                                        subscriptionTypesOptions: prev.subscriptionTypesOptions.includes(value)
                                                            ? prev.subscriptionTypesOptions
                                                            : [...prev.subscriptionTypesOptions, value],
                                                        subscriptionName: value
                                                    }));
                                                } else {
                                                    setFormData(prev => ({ ...prev, subscriptionName: "" }));
                                                }
                                            }}
                                        />
                                        {errors.subscriptionName && <p className="field-error">{errors.subscriptionName}</p>}
                                    </div>

                                    {/* Membership Cycle */}
                                    <div className="Subscription-form-group">
                                        <label className="input-label">Membership Cycle</label>
                                        <select
                                            className="subscription-input"
                                            value={formData.subscriptionCycle || ""}
                                            onChange={e => setFormData(prev => ({ ...prev, subscriptionCycle: e.target.value }))}
                                        >
                                            <option value="">Select Cycle</option>
                                            <option value="weekly">Weekly</option>
                                            <option value="monthly">Monthly</option>
                                            <option value="quarterly">Quarterly</option>
                                            <option value="half-yearly">Half-Yearly</option>
                                            <option value="yearly">Yearly</option>
                                            <option value="lifetime">Lifetime</option>
                                        </select>
                                    </div>

                                    {/* Membership Cycle Count */}
                                    <div className="Subscription-form-group">
                                        <label className="input-label">Cycle Count</label>
                                        <input
                                            type="text"
                                            className="subscription-input"
                                            value={formData.subscriptionCycleCount ?? ""}
                                            onChange={e => setFormData(prev => ({ ...prev, subscriptionCycleCount: e.target.value }))}
                                            placeholder="0"
                                        />
                                    </div>
                                </div>

                                <div className="Subscription-form-row subscription-form-grid">
                                    {/* Membership Amount Type */}
                                    <div className="Subscription-form-group">
                                        <label className="input-label">Value Type</label>
                                        <select
                                            className="subscription-input"
                                            value={formData.subscriptionValueType}
                                            onChange={(e) =>
                                                setFormData(prev => ({
                                                    ...prev,
                                                    subscriptionValueType: e.target.value,
                                                    subscriptionValue: e.target.value === "SERVICE" ? "0" : ""
                                                }))
                                            }
                                        >
                                            <option value="">Select Type</option>
                                            <option value="PERCENTAGE">PERCENTAGE</option>
                                            <option value="SERVICE">SERVICE</option>
                                        </select>
                                    </div>

                                    {/* Percentage or Spacer */}
                                    {formData.subscriptionValueType === "PERCENTAGE" ? (
                                        <div className="Subscription-form-group">
                                            <label className="input-label">Percentage (%)</label>
                                            <input
                                                type="number"
                                                className="subscription-input"
                                                placeholder="Enter %"
                                                value={formData.subscriptionValue}
                                                onChange={(e) => {
                                                    let val = Number(e.target.value);
                                                    if (val > 100) val = 100;
                                                    if (val < 1) val = 1;
                                                    setFormData(prev => ({ ...prev, subscriptionValue: val }));
                                                }}
                                            />
                                        </div>
                                    ) : (
                                        <div className="Subscription-form-group" style={{ visibility: 'hidden' }}></div>
                                    )}

                                    {/* Price */}
                                    <div className="Subscription-form-group">
                                        <label className="input-label">Price</label>
                                        <input
                                            type="number"
                                            className="subscription-input"
                                            placeholder="Enter Price"
                                            value={formData.priceOfMembership}
                                            onChange={(e) => {
                                                let val = Number(e.target.value);
                                                if (val < 0) val = 0;
                                                setFormData(prev => ({ ...prev, priceOfMembership: val }));
                                            }}
                                        />
                                    </div>

                                    {/* GST Percentage */}
                                    <div className="Subscription-form-group">
                                        <label className="input-label">GST (%)</label>
                                        <select
                                            className="subscription-input"
                                            disabled={!isGSTVerified}
                                            value={String(formData.gstPercentage ?? "")}
                                            onChange={(e) => {
                                                const gstPercentage = Number(e.target.value);
                                                const priceOfMembership = Number(formData.priceOfMembership || 0);
                                                const gstAmount = calculateGSTAmount(priceOfMembership, gstPercentage);
                                                setFormData(prev => ({
                                                    ...prev,
                                                    gstPercentage,
                                                    gstAmount: gstAmount
                                                }));
                                            }}
                                        >
                                            <option value="">Select GST</option>
                                            <option value="0">0%</option>
                                            <option value="5">5%</option>
                                            <option value="12">12%</option>
                                            <option value="18">18%</option>
                                        </select>
                                    </div>
                                </div>

                                <div className="Subscription-form-row subscription-form-grid">
                                    {/* GST Amount */}
                                    <div className="Subscription-form-group">
                                        <label className="input-label">GST Amount</label>
                                        <input
                                            type="number"
                                            className="subscription-input"
                                            placeholder="0.00"
                                            value={formData.gstAmount}
                                            readOnly
                                            style={{ backgroundColor: '#f8fafc' }}
                                        />
                                    </div>
                                </div>

                                <div className="Subscription-buttons" style={{ marginTop: '32px' }}>
                                    <button
                                        className="cancel-Product-button"
                                        onClick={() => navigate('/membership')}
                                        type="button"
                                        style={{ border: '1px solid #e2e8f0', borderRadius: '12px' }}
                                    >
                                        Cancel
                                    </button>
                                    <button className="add-Product-button" type="submit" style={{ background: '#3C0008', borderRadius: '12px' }}>
                                        <Icon icon="mdi:plus-circle" width="18" /> Add Plan
                                    </button>
                                </div>

                            </form>
                        </div>
                    ) : (
                        <>
                            <Typography variant="h6">Memberships</Typography>
                            <div className="subscription-widgets">
                                <div className="subscription-widgets-header">
                                    <div style={{ position: 'relative' }}>
                                        <div className="search-icon-wrapper" style={{ position: 'absolute', left: '16px', top: '50%', transform: 'translateY(-50%)', color: '#94a3b8' }}>
                                            <Icon icon="mdi:magnify" width="20" />
                                        </div>
                                        <input
                                            type="text"
                                            placeholder="Search memberships..."
                                            className="subscription-search-input"
                                            value={searchQuery}
                                            onChange={(e) => setSearchQuery(e.target.value)}
                                        />
                                    </div>
                                </div>
                                {(role === "SuperAdmin" || role === "SelfAdmin") && (
                                    <StoreSingleAllStoresSelect
                                        value={store}
                                        onChange={(s) => setStore(s)}
                                    />
                                )}
                                <button className="add-btn-subscription" onClick={() => navigate('/membership/add')}>
                                    <Icon icon="mdi:plus" width="20" /> Add Membership
                                </button>
                            </div>
                            <div className="subscription-divider"></div>
                            {subscriptions.length === 0 ? (
                                <p className="no-subscriptions" style={{ textAlign: 'center' }}>No memberships found.</p>
                            ) : (
                                <Box component={Paper}>
                                    <TableContainer
                                        component={Paper}
                                        sx={{
                                            maxHeight: 450,
                                            overflowY: "auto",
                                            overflowX: "auto",
                                            '&::-webkit-scrollbar': { width: '6px', height: '6px' },
                                            '&::-webkit-scrollbar-track': { background: '#f1f5f9' },
                                            '&::-webkit-scrollbar-thumb': { background: '#cbd5e1', borderRadius: '10px' },
                                            '&::-webkit-scrollbar-thumb:hover': { background: '#94a3b8' },
                                            boxShadow: 'none',
                                            backgroundColor: '#fff',
                                        }}
                                    >
                                        <Table className="custom-product-table" sx={{ minWidth: { xs: 900, sm: '100%' } }}>
                                            <TableHead className="custom-product-head">
                                                <TableRow>
                                                    {headings.map((heading, index) => (
                                                        <TableCell
                                                            key={index}
                                                            sx={{
                                                                border: "none",
                                                                padding: "12px 16px",
                                                                textAlign: "center",
                                                                position: "sticky",
                                                                top: 0,
                                                                zIndex: 1,
                                                                backgroundColor: "#3C0008",
                                                                whiteSpace: "nowrap",
                                                            }}
                                                        >
                                                            <Typography
                                                                variant="body2"
                                                                sx={{
                                                                    color: "#fff",
                                                                    fontSize: "14px",
                                                                    fontWeight: 600,
                                                                    textAlign: "center"
                                                                }}
                                                            >
                                                                {heading}
                                                            </Typography>
                                                        </TableCell>
                                                    ))}
                                                </TableRow>
                                            </TableHead>

                                            <TableBody>
                                                {subscriptions.length === 0 ? (
                                                    <TableRow>
                                                        <TableCell colSpan={9} sx={{ whiteSpace: "nowrap" }}>
                                                            <Typography
                                                                sx={{
                                                                    textAlign: "center",
                                                                    padding: "20px",
                                                                    fontWeight: 500
                                                                }}
                                                            >
                                                                No Memberships Found
                                                            </Typography>
                                                        </TableCell>
                                                    </TableRow>
                                                ) : (
                                                    subscriptions.map((subscription, index) => (
                                                        <TableRow key={subscription._id}>
                                                            <TableCell align="center" sx={{ whiteSpace: "nowrap" }}>
                                                                <Typography sx={commonCellStyle}>{index + 1}</Typography>
                                                            </TableCell>

                                                            <TableCell align="center" sx={{ whiteSpace: "nowrap" }}>
                                                                {subscription.subscriptionName}
                                                            </TableCell>

                                                            <TableCell align="center" sx={{ whiteSpace: "nowrap" }}>
                                                                {subscription.subscriptionCode}
                                                            </TableCell>

                                                            <TableCell align="center" sx={{ whiteSpace: "nowrap" }}>
                                                                {subscription.subscriptionValueType}
                                                            </TableCell>

                                                            <TableCell align="center" sx={{ whiteSpace: "nowrap" }}>
                                                                {subscription.subscriptionValueType === "SERVICE"
                                                                    ? "Service Benefit"
                                                                    : `${subscription.subscriptionValue}%`}
                                                            </TableCell>

                                                            <TableCell align="center" sx={{ whiteSpace: "nowrap" }}>
                                                                ₹{subscription.priceOfMembership}
                                                            </TableCell>

                                                            <TableCell align="center" sx={{ whiteSpace: "nowrap" }}>
                                                                {subscription.gstPercentage || 0}%
                                                            </TableCell>

                                                            <TableCell align="center" sx={{ whiteSpace: "nowrap" }}>
                                                                {subscription.subscriptionCycleCount && subscription.subscriptionCycleCount !== "1" && subscription.subscriptionCycleCount !== 1
                                                                    ? `${subscription.subscriptionCycleCount} ${subscription.subscriptionCycle}`
                                                                    : subscription.subscriptionCycle}
                                                            </TableCell>

                                                            <TableCell align="center" sx={{ whiteSpace: "nowrap" }}>
                                                                <Box
                                                                    sx={{
                                                                        display: "flex",
                                                                        gap: 2,
                                                                        justifyContent: "center"
                                                                    }}
                                                                >
                                                                    <Tooltip title="View Subscription">
                                                                        <Icon
                                                                            icon="mdi:eye-outline"
                                                                            width={20}
                                                                            style={{
                                                                                cursor: "pointer"
                                                                            }}
                                                                            onClick={async () => {
                                                                                try {
                                                                                    let storeName = "";

                                                                                    if (subscription.storeId) {
                                                                                        const res = await getData(
                                                                                            `stores/store/${subscription.storeId}`,
                                                                                            {},
                                                                                            sessionToken
                                                                                        );

                                                                                        storeName = res?.data?.storeName || "";
                                                                                    }

                                                                                    setViewSubscription({
                                                                                        ...subscription,
                                                                                        storeName
                                                                                    });

                                                                                    setIsViewMode(true);

                                                                                } catch (err) {
                                                                                    console.error(err);

                                                                                    setViewSubscription({
                                                                                        ...subscription,
                                                                                        storeName: ""
                                                                                    });

                                                                                    setIsViewMode(true);
                                                                                }
                                                                            }}
                                                                        />
                                                                    </Tooltip>

                                                                    <Tooltip title="Edit Subscription">
                                                                        <Icon
                                                                            icon="mdi:square-edit-outline"
                                                                            width={20}
                                                                            height={20}
                                                                            style={{ cursor: "pointer" }}
                                                                            onClick={async () => {

                                                                                let storeName = "";

                                                                                try {

                                                                                    const storeId =
                                                                                        subscription.storeId?._id ||
                                                                                        subscription.storeId;

                                                                                    const response = await getData(
                                                                                        `stores/store/${storeId}`,
                                                                                        {},
                                                                                        sessionToken
                                                                                    );

                                                                                    storeName = response?.data?.storeName || "";

                                                                                } catch (error) {
                                                                                    console.log(error);
                                                                                }

                                                                                setFormData({
                                                                                    ...subscription,
                                                                                    storeId: subscription.storeId?._id || subscription.storeId,
                                                                                    storeName
                                                                                });

                                                                                setEditSubscriptionId(subscription._id);
                                                                                setIsEditMode(true);
                                                                                setIsPopupMode(true);
                                                                            }}
                                                                        />
                                                                    </Tooltip>

                                                                    <Tooltip title="Delete Subscription">

                                                                        {role !== "SelfAdmin" && (
                                                                            <Icon
                                                                                icon="mdi:trash-can-outline"
                                                                                width={20}
                                                                                style={{
                                                                                    color: "#C10000",
                                                                                    cursor: "pointer"
                                                                                }}
                                                                                onClick={() => {
                                                                                    setOpen(true);
                                                                                    setSubscriptionToDelete(subscription._id);
                                                                                }}
                                                                            />
                                                                        )}
                                                                    </Tooltip>
                                                                </Box>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))
                                                )}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Box>
                            )}
                            <div className="supplier-bottom" style={{ marginTop: '20px' }}>
                                <div className="show-entries">
                                    <span className="text-label">Show</span>
                                    <select className="entries-select" value={limit} onChange={handleItemsPerPageChange}>
                                        <option value="5">5</option>
                                        <option value="10">10</option>
                                        <option value="25">25</option>
                                        <option value="all">All</option>
                                    </select>
                                    <span className="text-label">Entries</span>
                                </div>
                                <div className="showing-range">
                                    {limit === 'all'
                                        ? `Showing all ${totalCount} entries`
                                        : `Showing ${(currentPage - 1) * (limit === 'all' ? totalCount : Number(limit)) + 1} to ${Math.min(currentPage * (limit === 'all' ? totalCount : Number(limit)), totalCount)} of ${totalCount} entries`
                                    }
                                </div>
                                <div className="pagination-buttons">
                                    <button
                                        className="pagination-btn"
                                        disabled={currentPage === 1}
                                        onClick={() => handlePageChange("first")}
                                    >
                                        <Icon icon="mdi:chevron-double-left" />
                                    </button>
                                    <button
                                        className="pagination-btn"
                                        disabled={currentPage === 1}
                                        onClick={() => handlePageChange("prev")}
                                    >
                                        <Icon icon="mdi:chevron-left" />
                                    </button>
                                    <button
                                        className="pagination-btn"
                                        disabled={currentPage === totalPages || totalPages === 0}
                                        onClick={() => handlePageChange("next")}
                                    >
                                        <Icon icon="mdi:chevron-right" />
                                    </button>
                                    <button
                                        className="pagination-btn"
                                        disabled={currentPage === totalPages || totalPages === 0}
                                        onClick={() => handlePageChange("last")}
                                    >
                                        <Icon icon="mdi:chevron-double-right" />
                                    </button>
                                </div>
                            </div>
                        </>
                    )}
                    {isPopupMode && (
                        <div className="popup-overlay">
                            <div className="popup-wrapper">
                                <Icon
                                    icon={closeIcon}
                                    className="popup-close-icon-outside"
                                    onClick={() => {
                                        setIsPopupMode(false);
                                        setIsEditMode(false);
                                        setLoaderText("");
                                        setFormData({
                                            subscriptionName: '',
                                            price: '',
                                            subscriptionCycle: '',
                                            subscriptionCycleCount: '',
                                            storeId: '',
                                        });
                                    }}
                                />
                                <div className="popup-form">
                                    <form className="popup-form-body" onSubmit={handleUpdateSubscription}>
                                        <Typography variant="h6" textAlign={"center"} gutterBottom sx={{ color: '#191c24', mb: 4 }}>
                                            {isEditMode ? "Edit Membership" : "Add Membership"}
                                        </Typography>
                                        {/* Row 1 */}
                                        <div className="form-group-row">
                                            {/* Branch Name */}
                                            <div className="form-group">
                                                <label className="input-label">Store Name</label>

                                                <StoreMultiSelect
                                                    value={
                                                        formData.storeId
                                                            ? [{
                                                                value: formData.storeId,
                                                                label: formData.storeName
                                                            }]
                                                            : []
                                                    }
                                                    onChange={(val) => {
                                                        const storeId = val && val.length > 0 ? val[0].value : "";
                                                        const storeName = val && val.length > 0 ? val[0].label : "";
                                                        setFormData(prev => ({ ...prev, storeId, storeName }));
                                                    }}
                                                    loadStores={loadStores}
                                                    loggedInRole={role}
                                                    assignedStoreIds={adminStoreIds}
                                                    onAddStore={() => setIsAddStore(true)}
                                                    isMulti={false}
                                                />
                                            </div>

                                            {/* Membership Name */}
                                            <div className="form-group">
                                                <label className="input-label">Membership Name</label>

                                                <CreatableSelect
                                                    components={makeAnimated()}
                                                    placeholder="Select or type Membership Name"
                                                    isClearable
                                                    isSearchable

                                                    options={formData.subscriptionTypesOptions.map(type => ({
                                                        value: type,
                                                        label: type
                                                    }))}

                                                    value={
                                                        formData.subscriptionName
                                                            ? { value: formData.subscriptionName, label: formData.subscriptionName }
                                                            : null
                                                    }

                                                    onChange={(selectedOption) => {
                                                        if (selectedOption) {
                                                            const value = selectedOption.value.toUpperCase();

                                                            if (!formData.subscriptionTypesOptions.includes(value)) {
                                                                setFormData(prev => ({
                                                                    ...prev,
                                                                    subscriptionTypesOptions: [...prev.subscriptionTypesOptions, value],
                                                                    subscriptionName: value
                                                                }));
                                                            } else {
                                                                setFormData(prev => ({
                                                                    ...prev,
                                                                    subscriptionName: value
                                                                }));
                                                            }
                                                        } else {
                                                            setFormData(prev => ({ ...prev, subscriptionName: "" }));
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </div>

                                        {/* Row 2: Cycle and Count */}
                                        <div className="form-group-row">
                                            <div className="form-group">
                                                <label className="input-label">Membership Cycle</label>
                                                <select
                                                    className="subscription-input"
                                                    value={formData.subscriptionCycle || ""}
                                                    onChange={e => setFormData(prev => ({ ...prev, subscriptionCycle: e.target.value }))}
                                                >
                                                    <option value="">Select Cycle</option>
                                                    <option value="weekly">Weekly</option>
                                                    <option value="monthly">Monthly</option>
                                                    <option value="quarterly">Quarterly</option>
                                                    <option value="half-yearly">Half-Yearly</option>
                                                    <option value="yearly">Yearly</option>
                                                    <option value="lifetime">Lifetime</option>
                                                </select>
                                            </div>

                                            <div className="form-group">
                                                <label className="input-label">Cycle Count</label>
                                                <input
                                                    type="text"
                                                    className="subscription-input"
                                                    value={formData.subscriptionCycleCount ?? ""}
                                                    onChange={e => setFormData(prev => ({ ...prev, subscriptionCycleCount: e.target.value }))}
                                                    placeholder="0"
                                                />
                                            </div>
                                        </div>

                                        {/* Row 3: Value Type, Percentage (conditional), Price */}
                                        <div className="form-group-row">
                                            <div className="form-group">
                                                <label className="input-label">Value Type</label>
                                                <select
                                                    className="subscription-input"
                                                    value={formData.subscriptionValueType}
                                                    onChange={(e) =>
                                                        setFormData(prev => ({
                                                            ...prev,
                                                            subscriptionValueType: e.target.value,
                                                            subscriptionValue: e.target.value === "SERVICE" ? "0" : ""
                                                        }))
                                                    }
                                                >
                                                    <option value="">Select Type</option>
                                                    <option value="PERCENTAGE">PERCENTAGE</option>
                                                    <option value="SERVICE">SERVICE</option>
                                                </select>
                                            </div>

                                            {formData.subscriptionValueType === "PERCENTAGE" ? (
                                                <div className="form-group">
                                                    <label className="input-label">Percentage (%)</label>
                                                    <input
                                                        type="number"
                                                        className="subscription-input"
                                                        placeholder="Enter %"
                                                        value={formData.subscriptionValue}
                                                        onChange={(e) => {
                                                            let val = Number(e.target.value);
                                                            if (val > 100) val = 100;
                                                            if (val < 1) val = 1;
                                                            setFormData(prev => ({ ...prev, subscriptionValue: val }));
                                                        }}
                                                    />
                                                </div>
                                            ) : (
                                                <div className="form-group" style={{ visibility: 'hidden' }}></div>
                                            )}

                                            <div className="form-group">
                                                <label className="input-label">Price</label>
                                                <input
                                                    type="number"
                                                    className="subscription-input"
                                                    placeholder="Enter Price"
                                                    value={formData.priceOfMembership}
                                                    onChange={(e) => {
                                                        let val = Number(e.target.value);
                                                        if (val < 0) val = 0;
                                                        setFormData(prev => ({ ...prev, priceOfMembership: val }));
                                                    }}
                                                />
                                            </div>
                                        </div>

                                        {/* Row 3: GST Percentage, GST Amount, (Spacer) */}
                                        <div className="form-group-row">
                                            <div className="Subscription-form-group">
                                                <label className="input-label">GST Percentage</label>
                                                <select
                                                    className="category-input"
                                                    disabled={!isGSTVerified}
                                                    value={String(formData.gstPercentage ?? "")}
                                                    onChange={(e) => {
                                                        const gstPercentage = Number(e.target.value);
                                                        const priceOfMembership = Number(formData.priceOfMembership || 0);
                                                        const gstAmount = calculateGSTAmount(priceOfMembership, gstPercentage);
                                                        setFormData(prev => ({
                                                            ...prev,
                                                            gstPercentage,
                                                            gstAmount: gstAmount
                                                        }));
                                                    }}
                                                >
                                                    <option value="">Select GST</option>
                                                    <option value="0">0%</option>
                                                    <option value="5">5%</option>
                                                    <option value="12">12%</option>
                                                    <option value="18">18%</option>
                                                </select>
                                            </div>

                                            <div className="Subscription-form-group">
                                                <label className="input-label">GST Amount</label>
                                                <input
                                                    type="number"
                                                    className="subscription-input"
                                                    value={formData.gstAmount}
                                                    readOnly
                                                    style={{ backgroundColor: '#f8fafc' }}
                                                />
                                            </div>

                                            <div className="form-group" style={{ visibility: 'hidden' }}></div>
                                        </div>

                                        <div className="form-actions" style={{ borderTop: '1px solid #f1f5f9', paddingTop: '24px', marginTop: '24px', display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
                                            <button type="submit" className="add-Product-button" style={{ background: '#3C0008', borderRadius: '12px' }}>
                                                <Icon icon="mdi:check-circle" width="18" /> Update Membership
                                            </button>
                                            <button
                                                type="button"
                                                className="cancel-Product-button"
                                                onClick={() => setIsPopupMode(false)}
                                                style={{ border: '1px solid #e2e8f0', borderRadius: '12px' }}
                                            >
                                                Cancel
                                            </button>
                                        </div>

                                    </form>
                                </div>

                            </div>
                        </div>
                    )}
                    <Modal
                        open={open}
                        onClose={handleClose}
                        aria-labelledby="modal-modal-title"
                    >
                        <Box
                            sx={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                                width: 380,
                                background: "linear-gradient(135deg, #ffffff, #faf5f6)",
                                borderRadius: "20px",
                                boxShadow: "0 25px 70px rgba(0,0,0,0.35)",
                                p: 4,
                                outline: "none",
                                textAlign: "center",
                                overflow: "hidden"
                            }}
                        >
                            {/* ✅ TOP ICON BADGE */}
                            <Box
                                sx={{
                                    width: 74,
                                    height: 74,
                                    borderRadius: "50%",
                                    background: "linear-gradient(135deg, #3C0008 0%, #4d0000 100%)",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    margin: "0 auto 16px auto",
                                    color: "#fff",
                                    fontSize: 30,

                                    boxShadow: "0 12px 28px rgba(128, 0, 0,0.55)",
                                    animation: "deletePulse 1.6s infinite ease-in-out",

                                    "@keyframes deletePulse": {
                                        "0%": {
                                            transform: "scale(1)",
                                            boxShadow: "0 0 0 0 rgba(128, 0, 0,0.7)",
                                        },
                                        "70%": {
                                            transform: "scale(1.1)",
                                            boxShadow: "0 0 0 18px rgba(128, 0, 0,0)",
                                        },
                                        "100%": {
                                            transform: "scale(1)",
                                            boxShadow: "0 0 0 0 rgba(128, 0, 0,0)",
                                        },
                                    },
                                }}
                            >
                                🗑️
                            </Box>


                            {/* ✅ TITLE */}
                            <Typography
                                id="modal-modal-title"
                                variant="h6"
                                sx={{
                                    fontWeight: 700,
                                    color: "#2b2b2b",
                                    letterSpacing: "0.3px"
                                }}
                            >
                                Confirm Delete
                            </Typography>

                            {/* ✅ DESCRIPTION */}
                            <Typography
                                id="modal-modal-description"
                                sx={{
                                    mt: 1.2,
                                    fontSize: 14,
                                    color: "#666",
                                    lineHeight: 1.6
                                }}
                            >
                                Are you sure you want to delete this Memberships?
                            </Typography>

                            {/* ✅ BUTTON GROUP */}
                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    gap: 2.5,
                                    mt: 3.5
                                }}
                            >
                                {/* ✅ DELETE BUTTON */}
                                <Button
                                    variant="contained"
                                    onClick={handleDeleteSubscription}
                                    className="add-Product-button"
                                >
                                    Yes, Delete
                                </Button>

                                {/* ✅ CANCEL BUTTON */}
                                <Button
                                    variant="outlined"
                                    onClick={handleClose}
                                    className="cancel-Product-button"
                                >
                                    Cancel
                                </Button>
                            </Box>
                        </Box>
                    </Modal>
                </main>
                <Footer />
            </div>
            {
                isAddStore && (
                    <div className="popup-overlay">
                        <div className="popup-wrapper" style={{ maxWidth: '900px', width: '95%' }}>
                            <Icon
                                icon={closeIcon}
                                className="popup-close-icon-outside"
                                onClick={() => setIsAddStore(false)}
                            />
                            <div className="popup-form" style={{ maxHeight: '85vh', overflowY: 'auto', padding: '20px' }}>
                                <AddStoreForm
                                    onSuccess={() => {
                                        setIsAddStore(false);
                                        // Trigger store reload/refresh if needed
                                        // For now just close, user can re-search
                                    }}
                                    onCancel={() => setIsAddStore(false)}
                                />
                            </div>
                        </div>
                    </div>
                )
            }
            {isViewMode && viewSubscription && (
                <div className="popup-overlay">
                    <div className="popup-wrapper">
                        <Icon
                            icon={closeIcon}
                            className="popup-close-icon-outside"
                            onClick={() => {
                                setIsViewMode(false);
                                setViewSubscription(null);
                            }}
                        />

                        <div className="membership-view-card">
                            <div className="membership-banner">
                                <Icon icon="mdi:crown-outline" width={40} />
                                <h2>{viewSubscription.subscriptionName}</h2>
                                <p>{viewSubscription.subscriptionCode}</p>
                            </div>

                            <div className="membership-details-grid">

                                <div className="detail-card">
                                    <Icon icon="mdi:store-outline" width={24} />
                                    <div>
                                        <span>Store</span>
                                        <h4>{viewSubscription.storeName || ""}</h4>
                                    </div>
                                </div>

                                <div className="detail-card">
                                    <Icon icon="mdi:cash" width={24} />
                                    <div>
                                        <span>Price</span>
                                        <h4>₹{viewSubscription.priceOfMembership}</h4>
                                    </div>
                                </div>

                                <div className="detail-card">
                                    <Icon icon="mdi:percent-outline" width={24} />
                                    <div>
                                        <span>GST</span>
                                        <h4>{viewSubscription.gstPercentage}%</h4>
                                    </div>
                                </div>

                                <div className="detail-card">
                                    <Icon icon="mdi:calendar-month-outline" width={24} />
                                    <div>
                                        <span>Cycle</span>
                                        <h4>{viewSubscription.subscriptionCycle}</h4>
                                    </div>
                                </div>

                                <div className="detail-card">
                                    <Icon icon="mdi:gift-outline" width={24} />
                                    <div>
                                        <span>Benefit</span>
                                        <h4>
                                            {viewSubscription.subscriptionValueType === "SERVICE"
                                                ? "Service Benefit"
                                                : `${viewSubscription.subscriptionValue}%`}
                                        </h4>
                                    </div>
                                </div>

                                <div className="detail-card">
                                    <Icon icon="mdi:counter" width={24} />
                                    <div>
                                        <span>Cycle Count</span>
                                        <h4>{viewSubscription.subscriptionCycleCount}</h4>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div >
    );
};

export default SubscriptionPage;
